import { forwardRef, type Ref, type SVGProps } from "react";
const IconCheckmarkCircleFilledSVG = ({
  children,
  ...rest
}: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 32 32" ref={ref} {...rest}>{children}<path fill="currentColor" d="M16 2a14 14 0 1 0 14 14A14 14 0 0 0 16 2m6.7 9.58-9 9.82a1 1 0 0 1-1.44 0L8.8 17.53a1.08 1.08 0 0 1 0-1.48 1 1 0 0 1 1.41 0L13 19.19l8.3-9.09a1 1 0 0 1 1.41 0 1.08 1.08 0 0 1-.01 1.48" /></svg>;
const ForwardRef = forwardRef(IconCheckmarkCircleFilledSVG);
ForwardRef.displayName = "IconCheckmarkCircleFilled";
export { ForwardRef as IconCheckmarkCircleFilled };